import {
    recalcLocationCtaWidth,
    setLocationIconState,
    setupLocationCtaTag
} from './location-cta'

async function getIsLocationGranted() {
    if (!navigator.permissions) return false
    try {
        const status = await navigator.permissions.query({ name: 'geolocation' })
        return status.state === 'granted'
    } catch (e) {
        return false
    }
}

async function handleCityBtnCard () {
    const $btn = $('#city-btn-card')
    if (!$btn.length) return
    const isLocationGranted = await getIsLocationGranted()

    if (isLocationGranted) {
        const link = setupLocationCtaTag({
            elementId: 'city-btn-card',
            isEnabled: true,
            href: $btn.attr('href'),
            navigationDataId: 'Card_RainForecast_Link_Location',
            actionDataId: 'Card_RainForecast_Link_UseLocation'
        })
        setLocationIconState(link, 'enabled')
        recalcLocationCtaWidth(link)
        return
    }

    const button = setupLocationCtaTag({
        elementId: 'city-btn-card',
        isEnabled: false,
        navigationDataId: 'Card_RainForecast_Link_Location',
        actionDataId: 'Card_RainForecast_Link_UseLocation'
    })

    setLocationIconState(button, 'disabled')
    recalcLocationCtaWidth(button)
}

const init = () => {

    $(document)
        .off('click.cityBtnTracking', '#city-btn-card')
        .on('click.cityBtnTracking', '#city-btn-card', (e) => {
            const $target = $(e.currentTarget)
            const isAnchor = $target.is('a')
            const id = $target.attr('data-id') || (isAnchor ? 'Card_RainForecast_Link_Location' : 'Card_RainForecast_Link_UseLocation')
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ event: isAnchor ? 'click_link' : 'click_button', id })
        })

    handleCityBtnCard()
}

const cityBtnModal = { init }

export default cityBtnModal
